import { formatUserName } from '../../utils/utils';
import LiveKitPrimaryButton from '../LiveKitPrimaryButton';

import { Separator, Text } from '@amigoapp/doca-react';

const LiveKitTermsModal = ({ consentTerm, provider, onClose }) => (
	<div className="lk-modal-overlay lk-modal-overlay--fixed">
		<div className="lk-modal">
			<Text as="h3">Termo de Uso e Consentimento</Text>
			<Text className="doca-mb-4" size="extra-small" variant="gray" weight="light">Resolução CFM n°. 2.314</Text>
			<Separator className="doca-mb-4" />
			<Text className="lk-modal__body" loading={!consentTerm} size="small" variant="gray" weight="light">
				{consentTerm || `Aguarde, carregando o termo de ${formatUserName(provider.title, provider.name)}...`}
			</Text>
			<div className="lk-attach__actions">
				<LiveKitPrimaryButton onClick={onClose}>Fechar</LiveKitPrimaryButton>
			</div>
		</div>
	</div>
);

export default LiveKitTermsModal;
